import { createAction } from 'redux-actions';

export const clearReservationUpcomingEvents = createAction(
  'CLEAR_RESERVATION_UPCOMING_EVENTS'
);

export const reservationUpcomingEventsOnChangePage = createAction(
  'RESERVATION_UPCOMING_EVENTS_ON_CHANGE_PAGE'
);

export const reservationUpcomingEventsOnChangeOrder = createAction(
  'RESERVATION_UPCOMING_EVENTS_ON_CHANGE_ORDER'
);
